import axios from "../../.././axios-auth";

export const actions = {


    async serviceGetUsuarioOnline(context) {
        const endpoint = `/usuario/online`;
        const response = await axios(endpoint);
        localStorage.setItem("usuarioLogado", JSON.stringify(response.data));
        context.commit("setUsuarioLogadoNoSistema", response.data);
        if(response.data.matriculas){
            localStorage.setItem("matriculas", JSON.stringify(response.data.matriculas));
            context.commit("setMatriculas",response.data.matriculas)
        }
        if(response.data.modulos){
            localStorage.setItem("modulos", JSON.stringify(response.data.matriculas));
            context.commit("setModulos",response.data.modulos)
        }
        return response.data;
    },


};
